import { Button, Flex, Input, InputGroup, InputLeftAddon, Td, Tooltip, Tr } from "@chakra-ui/react";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { ContactPersonDto } from "../../../../autogen/bff-api";

interface Props {
  initialContactPerson: ContactPersonDto;
  onSave: (updatedContactPerson: ContactPersonDto) => void;
  onCancel: () => void;
  canUpdateContactPersons: boolean;
}

export const InlineContactPersonEditForm = ({
  initialContactPerson,
  onSave,
  onCancel,
  canUpdateContactPersons,
}: Props) => {
  const [editableContact, setEditableContact] = useState<ContactPersonDto>(initialContactPerson);

  useEffect(() => {
    setEditableContact(initialContactPerson);
  }, [initialContactPerson]);

  const handleSave = () => {
    onSave(editableContact);
  };

  return (
    <Tr>
      <Td>
        <Input
          value={editableContact.name}
          onChange={(e) =>
            setEditableContact({
              ...editableContact,
              name: e.target.value,
            })
          }
          size="sm"
        />
      </Td>
      <Td>
        <Input
          value={editableContact.title || ""}
          onChange={(e) =>
            setEditableContact({
              ...editableContact,
              title: e.target.value,
            })
          }
          size="sm"
        />
      </Td>
      <Td>
        <Tooltip
          label={t("To change an email, please delete this contact and add a new one.")}
          placement="top"
          shouldWrapChildren
        >
          <Input value={editableContact.email} isReadOnly size="sm" disabled />
        </Tooltip>
      </Td>
      <Td>
        <InputGroup size="sm">
          <InputLeftAddon rounded="md">+47</InputLeftAddon>
          <Input
            rounded="md"
            backgroundColor="smBackground"
            placeholder={t("Phone number") || ""}
            type="tel"
            value={editableContact.phoneNumber?.number || ""}
            onChange={(e) => {
              setEditableContact({
                ...editableContact,
                phoneNumber: {
                  number: e.target.value,
                  callingCode: {
                    countryAlpha3Code: "NOR",
                    value: "47",
                    countryName: "Norway",
                  },
                },
              });
            }}
          />
        </InputGroup>
      </Td>
      {canUpdateContactPersons && (
        <Td>
          <Flex gap={2}>
            <Button size="sm" colorScheme="blue" onClick={handleSave}>
              {t("Save")}
            </Button>
            <Button size="sm" variant="ghost" onClick={onCancel}>
              {t("Cancel")}
            </Button>
          </Flex>
        </Td>
      )}
    </Tr>
  );
};
